import {
	Button,
	DataTable,
	DataTableColumn,
	PageHeader,
	Tabs,
	TabsPanel
} from '@salesforce/design-system-react';
import * as React from 'react';
import FakeLookup from 'lib/FakeLookup';
import CustomerIcon from 'lib/CustomerIcon';
import LinkCell from 'lib/Overview/link-cell';
import campingTrip from './camping-trip.svg';

const results = [
	{ id: 'MD33DCF54ED...', name: 'Fabian Muessig', email: 'fmuessig@salesforce.com', phone: '+49(0)9560 990190',
		address: 'Erika-Mann-Strasse 31-37, 80636 München'},
	{ id: 'MD02X766JF38...', name: 'Fabian Müller', email: 'fabian8327@gmail.com', phone: '+49(0) 371987730',
		address: 'Kurfürstendamm 194, 10707 Berlin'},
];

type SearchState = {
	search: boolean
};

type SearchProps = {
	onClick: () => void;
 };

class Search extends React.Component<SearchProps, SearchState> {
	constructor (props: SearchProps) {
		super(props);
		this.state = {
			search: false
		};
	}

	showResults = () => {
		this.setState({ search: true });
	}

	renderEmpty () {
		return (
			<div className="slds-illustration slds-illustration_large slds-text-align_center slds-m-top_xx-large">
				<object data={campingTrip} />
				<div className="slds-text-longform slds-m-top_large">
					<h3 className="slds-text-heading_medium">Start searching for Customer Profiles</h3>
					<p className="slds-text-body_regular">You can search for customers using Customer 360 ID or email or name</p>
				</div>
			</div>
		);
	}

	renderResults () {
		return (
			<div className="slds-box results">
				<span className="slds-text-small">2 Results • Sorted by Relevance</span>
				<DataTable items={results}>
					<DataTableColumn label="ID" key="id" property="id">
						<LinkCell handleClick={this.props.onClick} />
					</DataTableColumn>
					<DataTableColumn label="Name" key="name" property="name" />
					<DataTableColumn label="Email" key="email" property="email" />
					<DataTableColumn label="Phone" key="phone" property="phone" />
					<DataTableColumn label="Address" key="source" property="address" />
				</DataTable>
			</div>
		);
	}

	render () {
		return (
			<div className="stewardship-search">
				<PageHeader
					icon={<CustomerIcon />}
					label=""
					title="Data Stewardship"
					variant="objectHome"
				/>
				<Tabs defaultSelectedIndex={1}>
					<TabsPanel label="Request Queue" />
					<TabsPanel label="Search" />
				</Tabs>
				<FakeLookup className="stewardship-search-lookup" entity="Name" placeholder="Enter name to search"  />
				<Button className="stewardship-search-button" label="Search" onClick={this.showResults} variant="brand" />
				{this.state.search ? this.renderResults() : this.renderEmpty()}
			</div>
		);
	}
}

export default Search;



// WEBPACK FOOTER //
// ./src/DataStewardship/search.tsx